import { render, staticRenderFns } from "./RecentFeedHistoryDropdown.vue?vue&type=template&id=4803093c&scoped=true"
import script from "./RecentFeedHistoryDropdown.vue?vue&type=script&lang=js"
export * from "./RecentFeedHistoryDropdown.vue?vue&type=script&lang=js"
import style0 from "./RecentFeedHistoryDropdown.vue?vue&type=style&index=0&id=4803093c&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4803093c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs_diego/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4803093c')) {
      api.createRecord('4803093c', component.options)
    } else {
      api.reload('4803093c', component.options)
    }
    module.hot.accept("./RecentFeedHistoryDropdown.vue?vue&type=template&id=4803093c&scoped=true", function () {
      api.rerender('4803093c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/RecentFeedHistoryDropdown.vue"
export default component.exports